import { Link, createFileRoute } from "@tanstack/react-router";
import BreadcrumbJsonLd from "@/components/common/breadcrumbJsonLd";

const SITE_URL = "https://datafirstjobs.com";

export const Route = createFileRoute("/locations")({
  loader: ({ context }) => ({ locations: context.locations }),
  head: () => ({
    meta: [
      { title: "Browse data jobs by location | Data First Jobs" },
      {
        name: "description",
        content: "Browse current data jobs by country, state, and province.",
      },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/locations` }],
  }),
  component: LocationsPage,
});

function LocationsPage() {
  const { locations } = Route.useLoaderData();

  return (
    <>
      <BreadcrumbJsonLd
        items={[{ name: "Home", url: SITE_URL }, { name: "Locations" }]}
      />
      <section className="mx-auto mt-16 max-w-5xl px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-semibold tracking-tight text-gray-900 md:text-6xl">
          Data jobs by location
        </h1>
        <p className="mt-4 max-w-2xl text-lg text-gray-600">
          Explore current roles by country, state, and province.
        </p>
        <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {locations.countries.map((country) => (
            <section key={country.slug}>
              <h2 className="text-lg font-semibold text-gray-900">
                <Link
                  to="/$slug"
                  params={{ slug: country.slug }}
                  className="hover:text-orange-700"
                >
                  {country.name}
                </Link>
              </h2>
              {country.states.length > 0 && (
                <ul className="mt-3 space-y-2 text-sm" role="list">
                  {country.states.map((state) => (
                    <li key={state.slug}>
                      <Link
                        to="/$slug"
                        params={{ slug: state.slug }}
                        className="text-gray-600 hover:text-orange-700"
                      >
                        {state.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </section>
    </>
  );
}
